import { RootState } from "store";

export const getPolicyProduct = (state: RootState) => state.policy.productDetail;
export const getIsPolicyProductAD = (state: RootState) =>
  state.policy.productDetail.slug === "wysh-accidental-death";
